export default __webpack_public_path__ + "static/media/icon-settings.7e15a734.svg";